$(document).ready(() => {
  if($('.blogFeed').length){


  const origin = window.location.origin || (window.location.protocol + '//' + window.location.host);
  const blogPath = $('.blogFeed').data('blog-path') || '/blog/';
  const blogUrl = new URL(blogPath, origin).toString();
  const cacheKey = 'blogFeed:' + blogUrl;
  const cached = sessionStorage.getItem(cacheKey);
  if (cached) {
    $('.blogFeed').html(cached);
    $('.blogFeed .news-item').not(':nth-child(-n+3)').remove();
    $('.news-item').each((_, el) => {
      const $t = $(el);
      $t.find('.text').append('<a href="'+$t.find('.title').attr('href')+'" class="readMore">Číst více...</a>');
      $t.find('.image img').attr('src', $t.find('.image img').attr('data-src'));
    });
  } else {
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: blogUrl,
      success: e => {
        const a = shoptet.common.createDocumentFromString(e);
        const t = $(a).find('.news-wrapper').html();
        if (t) {
          $('.blogFeed').html(t);
          $('.blogFeed .news-item').not(':nth-child(-n+3)').remove();
          $('.news-item').each((_, el) => {
            const $t = $(el);
            $t.find('.text').append('<a href="'+$t.find('.title').attr('href')+'" class="readMore">Číst více...</a>');
            $t.find('.image img').attr('src', $t.find('.image img').attr('data-src'));
          });
          sessionStorage.setItem(cacheKey, t);
        } else {
          console.warn('Prvek .news-wrapper není v odpovědi nalezen.');
        }
      },
      error: (jqXHR, textStatus, errorThrown) => {
        console.error('Chyba při načítání blogu:', textStatus, errorThrown);
      }
    }).done(function(){
    });
  }
    }
});
